var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareMousePointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "a/icons/micro/16/square-mouse-pointer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/16/square-mouse-pointer",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 0)",
    stroke: "color(display-p3 0.000 0.000 0.000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02266667,8.454 C7.97354446,8.33076511 8.00250161,8.19011733 8.09630947,8.09630947 C8.19011733,8.00250161 8.33076511,7.97354446 8.454,8.02266667 L14.454,10.356 C14.5858366,10.4075149 14.670763,10.5366733 14.6658128,10.6781306 C14.6608625,10.8195879 14.5671152,10.9424937 14.432,10.9846667 L12.136,11.6966667 C11.9256829,11.7616915 11.7610249,11.9263495 11.696,12.1366667 L10.9846667,14.432 C10.9424937,14.5671152 10.8195879,14.6608625 10.6781306,14.6658128 C10.5366733,14.670763 10.4075149,14.5858366 10.356,14.454 L8.02266667,8.454 Z",
    id: "Path",
    strokeWidth: 0.833333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,7.33333333 L14,3.33333333 C14,2.59695367 13.4030463,2 12.6666667,2 L3.33333333,2 C2.59695367,2 2,2.59695367 2,3.33333333 L2,12.6666667 C2,13.4030463 2.59695367,14 3.33333333,14 L7.33333333,14",
    id: "Path",
    strokeWidth: 0.833333333
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMousePointer);
export default __webpack_public_path__ + "static/media/square-mouse-pointer.7369c54542a73b61d2215b8d9a0267d8.svg";
export { ForwardRef as ReactComponent };